import { render, staticRenderFns } from "./culumTop.vue?vue&type=template&id=5f1cd5cb&scoped=true&"
import script from "./culumTop.vue?vue&type=script&lang=js&"
export * from "./culumTop.vue?vue&type=script&lang=js&"
import style0 from "./culumTop.vue?vue&type=style&index=0&id=5f1cd5cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1cd5cb",
  null
  
)

export default component.exports